import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import {logout} from '../actions/UsuarioActions';

import $ from "jquery";

class Header extends React.Component {

  state = {
    dropdown: false,
    isScrolled: false 
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleScroll = () => {
    if (window.scrollY > 10) {
      this.setState({ isScrolled: true });
    } else {
      this.setState({ isScrolled: false });
    }
  }

  handleClickOutside = (e) => {
    if (this.state.dropdown && !e.target.closest('.user-profile-wrapper')) {
      this.setState({dropdown: false});
    }
  }

  logout () {
    localStorage.clear();
    this.props.logout();
  }

  abrirOverlay () {
    if (window.innerWidth <= 767) {
      if (document.querySelector("body").classList.contains("sidebar-open")) {
        $("#overlay-menuPrincipal").css("display", "block");
      } else {
        $("#overlay-menuPrincipal").css("display", "none");
      }
    }
  }

  toggleDropdown = (e) => {
    e.stopPropagation();
    this.setState({dropdown: !this.state.dropdown});
  }

  getInitials = (nome) => {
    if (!nome) return '';
    const names = nome.split(' ');
    if (names.length >= 2) {
      return (names[0][0] + names[1][0]).toUpperCase();
    }
    return nome.substring(0, 2).toUpperCase();
  }

  getFirstName = (nome) => {
    if (!nome) return '';
    return nome.includes("@") ? nome.split("@")[0] : nome.split(" ")[0];
  }

  render () {
    const { dropdown } = this.state;
    const { usuario } = this.props;

    const styles = {
      header: {
        position: 'relative',
        height: '50px',
        background: '#222d32',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s ease',
        zIndex: 1050,
        borderBottom: '3px solid #da291c'
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%',
        padding: '0 20px',
        maxWidth: '100%'
      },
      logoSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
      },
      sidebarToggle: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        transition: 'all 0.2s ease',
        borderRadius: '4px'
      },
      toggleIcon: {
        width: '22px',
        height: '2px',
        background: '#e5e5e5',
        borderRadius: '2px',
        transition: 'all 0.2s ease'
      },
      logoLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        textDecoration: 'none',
        transition: 'all 0.2s ease'
      },
      logoMini: {
        width: '130px',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        borderRadius: '6px',
        padding: '5px'
      },
      logoImage: {
        width: '140%',
        height: '140%',
        objectFit: 'contain'
      },
      logoText: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      },
      logoTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#ffffff',
        letterSpacing: '-0.3px'
      },
      logoSubtitle: {
        fontSize: '10px',
        color: '#dc2626',
        fontWeight: '600',
        letterSpacing: '1px',
        textTransform: 'uppercase'
      },
      userSection: {
        position: 'relative'
      },
      userProfileBtn: {
        background: 'transparent',
        border: '1px solid #3a3a3a',
        borderRadius: '6px',
        padding: '5px 10px 5px 5px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
      },
      userProfileBtnHover: {
        border: '1px solid #dc2626',
        background: 'rgba(220, 38, 38, 0.05)'
      },
      avatar: {
        width: '30px',
        height: '30px',
        borderRadius: '5px',
        background: '#dc2626',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600',
        fontSize: '12px',
        color: 'white',
        transition: 'all 0.2s ease'
      },
      avatarStatus: {
        display: 'none'
      },
      userInfo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '1px'
      },
      userName: {
        color: '#ffffff',
        fontSize: '13px',
        fontWeight: '600',
        lineHeight: '1.2'
      },
      userRole: {
        color: '#999999',
        fontSize: '10px',
        fontWeight: '500'
      },
      dropdownArrow: {
        color: '#999999',
        fontSize: '9px',
        transition: 'transform 0.2s ease',
        transform: dropdown ? 'rotate(180deg)' : 'rotate(0deg)'
      },
      dropdown: {
        position: 'absolute',
        top: '45px',
        right: '0',
        width: '220px',
        background: '#2a2a2a',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        opacity: dropdown ? 1 : 0,
        visibility: dropdown ? 'visible' : 'hidden',
        transform: dropdown ? 'translateY(0)' : 'translateY(-8px)',
        transition: 'all 0.2s ease',
        overflow: 'hidden',
        border: '1px solid #3a3a3a'
      },
      dropdownHeader: {
        padding: '14px',
        background: '#242424',
        borderBottom: '1px solid #3a3a3a',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      },
      dropdownAvatar: {
        width: '36px',
        height: '36px',
        borderRadius: '6px',
        background: '#dc2626',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: '600',
        color: 'white'
      },
      dropdownUserInfo: {
        flex: 1,
        overflow: 'hidden'
      },
      dropdownUserName: {
        margin: 0,
        color: '#ffffff',
        fontSize: '13px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      dropdownUserEmail: {
        margin: '2px 0 0 0',
        color: '#999999',
        fontSize: '10px',
        fontWeight: '500'
      },
      dropdownList: {
        listStyle: 'none',
        margin: 0,
        padding: '6px'
      },
      dropdownItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '9px 12px',
        color: '#e5e5e5',
        textDecoration: 'none',
        borderRadius: '6px',
        transition: 'all 0.2s ease',
        fontSize: '13px',
        fontWeight: '500',
        background: 'transparent',
        border: 'none',
        width: '100%',
        cursor: 'pointer',
        textAlign: 'left'
      },
      dropdownItemHover: {
        background: '#333333',
        color: '#dc2626'
      },
      dropdownIcon: {
        width: '16px',
        fontSize: '13px',
        color: '#999999'
      },
      divider: {
        height: '1px',
        background: '#3a3a3a',
        margin: '6px 0',
        border: 'none'
      }
    };

    return (
      <header style={styles.header}>
        <div style={styles.container}>
          <div style={styles.logoSection}>
            <button
              style={styles.sidebarToggle}
              onClick={this.abrirOverlay.bind(this)}
              data-toggle="offcanvas"
              aria-label="Toggle navigation"
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#2a2a2a';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <span style={styles.toggleIcon}></span>
              <span style={styles.toggleIcon}></span>
              <span style={styles.toggleIcon}></span>
            </button>

            <Link to="/" style={styles.logoLink}>
              <div style={styles.logoMini}>
                <img
                  src="/images/logo-att.png"
                  alt="Logo da Alpha"
                  style={styles.logoImage}
                />
              </div>
              <div style={styles.logoText}>           
              </div>
            </Link>
          </div>

          <div style={styles.userSection} className="user-profile-wrapper">
            <button
              onClick={this.toggleDropdown}
              style={styles.userProfileBtn}
              type="button"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, styles.userProfileBtnHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.border = '1px solid #3a3a3a';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <div style={styles.avatar}>
                <span>{this.getInitials(usuario.nome)}</span>
                <div style={styles.avatarStatus}></div>
              </div>
              <div style={styles.userInfo}>
                <span style={styles.userName}>{this.getFirstName(usuario.nome)}</span>
                <span style={styles.userRole}>
                  {usuario.tipo === "formando" ? "Formando" : "Usuário"}
                </span>
              </div>
              <i className="fas fa-chevron-down" style={styles.dropdownArrow}></i>
            </button>

            <div style={styles.dropdown}>
              <div style={styles.dropdownHeader}>
                <div style={styles.dropdownAvatar}>
                  <span>{this.getInitials(usuario.nome)}</span>
                </div>
                <div style={styles.dropdownUserInfo}>
                  <p style={styles.dropdownUserName}>{usuario.nome}</p>
                  <p style={styles.dropdownUserEmail}>
                    {usuario.tipo === "formando" ? "Área do Formando" : "Painel de Controle"}
                  </p>
                </div>
              </div>

              <ul style={styles.dropdownList}>
                {usuario.tipo === "formando" && (
                  <>
                    <li>
                      <Link
                        to="/meus-dados"
                        style={styles.dropdownItem}
                        onMouseEnter={(e) => {
                          Object.assign(e.currentTarget.style, styles.dropdownItemHover);
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'transparent';
                          e.currentTarget.style.color = '#e5e5e5';
                        }}
                      >
                        <i className="fas fa-user-circle" style={styles.dropdownIcon}></i>
                        <span>Meus Dados</span>
                      </Link>
                    </li>
                    <hr style={styles.divider} />
                  </>
                )}
                <li>
                  <button
                    onClick={this.logout.bind(this)}
                    style={styles.dropdownItem}
                    onMouseEnter={(e) => {
                      Object.assign(e.currentTarget.style, styles.dropdownItemHover);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = '#e5e5e5';
                    }}
                  >
                    <i className="fas fa-sign-out-alt" style={styles.dropdownIcon}></i>
                    <span>Sair</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado
  };
};

export default connect(mapStateToProps, {logout})(Header);
